<template>
  <div>
    <el-popover popper-class="copyPop" placement="bottom" trigger="hover">
      <el-button @click="copy" size="mini">复制</el-button>
      <div slot="reference" ref="copyRef">
        <slot name="referenceChild"></slot>
      </div>
    </el-popover>
  </div>
</template>


<script>
export default {
  methods: {
    copy() {
      const copyElement = document.querySelector("#copyInput");
      copyElement.value = this.$refs.copyRef.innerText.trim();
      copyElement.select();
      document.execCommand("copy");
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
  },
};
</script>

<style>
.copyPop {
  min-width: auto;
  padding: 0;
}
.copyPop .popper__arrow {
  left: 23px !important;
}
</style>